import { render, staticRenderFns } from "./SharePoster.vue?vue&type=template&id=5c84baec&scoped=true&"
import script from "./SharePoster.vue?vue&type=script&lang=js&"
export * from "./SharePoster.vue?vue&type=script&lang=js&"
import style0 from "./SharePoster.vue?vue&type=style&index=0&id=5c84baec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c84baec",
  null
  
)

export default component.exports